import React, {useContext} from 'react';
import {toast} from "react-toastify";
import axios from "axios";
import {prefixUrl} from "../../utils/utilsData";
import utilsFunction from "../../utils/utilsFunction";
import {OrderViewContext} from "./OrderViewContext";

function PaymentStatus({setReload,cell}) {
  const helper = useContext(OrderViewContext);
  const setData = helper.setData
  const data = helper.data

  const orderId = cell.getData().orderId
  const handleChange = async (e) => {

    const data = {
      request: "changeCartState", data: {
        "orderId": orderId, "state": e.target.value
      }
    }
    const toastId = toast.loading('در حال تغییر وضعیت...')

    const res = await axios.post(prefixUrl() + '/cartTable/', data)
    toast.dismiss(toastId)
    if (res.data.status) {
      toast.success(res.data.message)
      setReload(utilsFunction.randomNumberGenerator())
    } else {
      toast.error(res.data.message)
    }

  }
  return <select
    onChange={handleChange}
    className={"rtl"}
    value={cell.getData()['paymentStatus']}>
    {data?.tableData?.paymentStatusList?.map((v,index)=> {
      return <option key={index} value={v.value}>{v.label}</option>
    })}




  </select>
}

export default PaymentStatus;